import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { WAIT_CURSOR } from "@core/tokens/wait-cursor.token";
import { WaitCursorService } from "@core/services/wait-cursor.service";

export const waitCursorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const useWaitCursor: boolean = req.context.get(WAIT_CURSOR);

  if (!useWaitCursor) return next(req);

  const waitCursor: WaitCursorService = inject(WaitCursorService);

  waitCursor.start();

  return next(req).pipe(finalize(() => waitCursor.stop()));
};
